import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import UploadSection_vue_vue_type_script_setup_true_lang_default from "./UploadSection.vue.script.js";
/* empty css                            */
//#region src/components/UploadSection.vue
var UploadSection_default = /*#__PURE__*/ _plugin_vue_export_helper_default(UploadSection_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-9621c76b"]]);
//#endregion
export { UploadSection_default as default };

//# sourceMappingURL=UploadSection.vue.js.map